export default "https://storage.googleapis.com/prepweb-prod/dist/aa15d5a4e0edea77e076c4548af82eaf.svg";